<template>
    <div class="partyworkmore">
        <div class="box_bg_1 flex-col">
          </div>
          <div class="box_5 flex-col">
            <div class="box_6 flex-row">
              <div class="text-wrapper_1 flex-col justify-between">
                <span class="text_13">当前位置：首页&nbsp;&gt;&nbsp;党务建设</span>
                <span class="text_14">{{modelitemName}}</span>
              </div>
              <div class="box_7 flex-row justify-between">
                <div class="text-wrapper_2 flex-col" @click="setState('PT01')"   :style="{'background-color':form.modelitem=='PT01'?'rgba(176, 23, 1, 1)':'white'}">
                  <span class="text_15" :style="{'color':form.modelitem=='PT01'?'white':'rgba(176, 23, 1, 1)'}">党建工作</span>
                </div>
                <div class="text-wrapper_3 flex-col" @click="setState('PT02')"  :style="{'background-color':form.modelitem=='PT02'?'rgba(176, 23, 1, 1)':'white'}">
                  <span class="text_16"  :style="{'color':form.modelitem=='PT02'?'white':'rgba(176, 23, 1, 1)'}">党建文化</span>
                </div>
                <div class="text-wrapper_4 flex-col" @click="setState('PT03')" :style="{'background-color':form.modelitem=='PT03'?'rgba(176, 23, 1, 1)':'white'}">
                  <span class="text_17"  :style="{'color':form.modelitem=='PT03'?'white':'rgba(176, 23, 1, 1)'}">社会责任</span>
                </div>
                <div class="text-wrapper_5 flex-col" @click="setState('PT04')" :style="{'background-color':form.modelitem=='PT04'?'rgba(176, 23, 1, 1)':'white'}">
                  <span class="text_18" :style="{'color':form.modelitem=='PT04'?'white':'rgba(176, 23, 1, 1)'}">党建活动</span>
                </div>
              </div>
              <div class="text-wrapper_6 flex-col">
                <span class="text_19">4001-300-137</span>
              </div>
              <div class="box_8 flex-row">
                <div class="image-text_1 flex-col justify-between" style="cursor:pointer">
                  <img
                    class="label_1"
                    referrerpolicy="no-referrer"
                    src="@/assets/client/tel.png"
                  />
                  <span class="text-group_1">业务咨询</span>
                </div>
              </div>
            </div>
            <div class="image-wrapper_1 flex-row">
              <img
                class="image_2"
                referrerpolicy="no-referrer"
                src="@/assets/client/dx_2.png"
              />
            </div>

            <template v-for="(item,index) in loopData0" >
              <div class="box_11 flex-row">
                <div class="image-text_3 flex-row justify-between">
                  <!-- <div class="block_2 flex-col"></div> -->
                  <img class="block_2 flex-col"  :src="(`${item.viewPath}`)"></img>
                  <div class="text-group_3 flex-col">
                    <div class="text-wrapper_9 flex-row justify-between">
                      <span class="text_23" @click="selelctNews(item)"
                        >{{item.title}}</span
                      >
                      <span class="text_24"
                        >&nbsp;&nbsp;发布时间：{{item.publishdate}}</span
                      >
                    </div>
                    <span class="paragraph_2"
                      >{{item.subtitle.length>127?item.subtitle.substring(0,127)+"...":item.subtitle}}</span
                    >
                  </div>
                </div>
                </div>
                <div class="image-wrapper_2 flex-row">
                    <img
                    class="image_3"
                    referrerpolicy="no-referrer"
                    src="@/assets/client/underline.png"
                  />
                </div>
            </template>
            <div class="box_18 flex-row">
              <el-pagination ref="mypage" @current-change="handleCurrentChange" :page-sizes="[12]" :page-size="form.pageSize"
                  :current-page="form.pageIndex" layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
            </div>

          </div>
    </div>
</template>
<script>
  export default{
    data(){
        return{
            form:{
                pageSize: 6,
                pageIndex: 1,
                modelitem:"PT01",
                newsmodel:"PartyType"
            },
            modelitemName:"党建工作",
            total:0,
            loading:false,
            loopData0:[],
            FileAddress:"",
        }
    },
    methods:{
       //当前页变化事件
        handleCurrentChange(val) {
                let that = this;
                that.form.pageIndex = val;
                that.getNewsCenterlist();
        },
        setState(state){
            let that = this;
            that.form.modelitem = state;
            if(state=='PT01'){
              that.modelitemName ="党建工作";
            }
            if(state=='PT02'){
              that.modelitemName ='党建文化';
            }
            if(state=='PT03'){
              that.modelitemName ='社会责任';
            }
            if(state=='PT04'){
              that.modelitemName ='党建活动';
            }
            that.getNewsCenterlist();
        },
        getNewsCenterlist()
        {
          let that = this;
                that.$api.post("/Client/getNewsCenterlist", that.form,
                    function (res) {
                        if (res.code === "200") {
                          that.loopData0 =[];
                          res.data.forEach(item=>{
                            that.loopData0.push({
                                id:item.id,
                                title:item.news_title,
                                subtitle:item.news_subtitle,
                                publishdate:item.publishdate,
                                is_open_attachment:item.is_open_attachment,
                                url:item.url,
                                is_open_url:item.is_open_url,
                                viewPath: (that.FileAddress + item.ViewFilePath.replace(" ", "%20").replace(/\\/g, '/')),
                                FilePath:(that.FileAddress + item.FilePath.replace(" ", "%20").replace(/\\/g, '/')),
                              });
                          });
                            that.total = res.count;
                            that.loading = false;
                        }
                    },
                    function (res) {
                        that.$message.error("服务异常，信息出错");
                    }
                );
          },
          selelctNews(item){
            var _this = this;
              if(item.is_open_attachment=='1'){
                 window.open(item.FilePath, '_blank');
              } else if(item.is_open_url=='1')
              {
                window.open(item.url, '_blank');
              }
              else{
                _this.$router.push({
                    path: "/Client/PartyWorkDetails",
                    query: {
                    id:item.id,
                    modelitem:this.form.modelitem,
                    newsmodel:this.form.newsmodel
                },
              });
              }
          }
    },
    mounted(){
      let that = this;
      if(this.$route.query.modelitem!=null&&this.$route.query.modelitem!=undefined)
      {
        that.form.modelitem = this.$route.query.modelitem;
          if(this.$route.query.modelitem=='PT01'){
            that.modelitemName ="党建工作";
          }
          if(this.$route.query.modelitem=='PT02'){
            that.modelitemName ='党建文化';
          }
          if(this.$route.query.modelitem=='PT03'){
            that.modelitemName ='社会责任';
          }
          if(this.$route.query.modelitem=='PT04'){
            that.modelitemName ='党建活动';
          }
      }
      that.getNewsCenterlist();
      that.loading = true;
      that.FileAddress = process.env.VUE_APP_FileAddress.replace('fileapi/', '');
    },
    watch:{
    }
}
</script>
<style scoped>
@import '../../../assets/client/partyworkmore.css';
</style>
